import {useMemo, useEffect, useCallback} from 'react';
import {isAndroid, isIOS, isIOS13, isMobile} from 'react-device-detect';
import {useDispatch, useSelector} from 'react-redux';

import {AppState} from '../../../redux';
import {setGoToAppHidden} from '../../../redux/actions/runtime/menu';
import {contentSelector} from '../../../redux/selectors/resources';
import getStyle from './style';
import {View} from './view';

export const useGoToApp = () => {
  const content = useSelector(contentSelector());
  const isClosed = useSelector((state: AppState) => state.runtime.menu.isGoToAppHidden);

  const href = useMemo(() => {
    if (isAndroid) {
      return content.footer.stores.googlePlay;
    }

    if (isIOS || isIOS13) {
      return content.footer.stores.appStore;
    }

    return '';
  }, [content]);

  return useMemo(
    () => ({
      isVisible: !isClosed && Boolean(href),
      isClosed,
      href,
    }),
    [isClosed, href],
  );
};

export const GoToApp = () => {
  const dispatch = useDispatch();
  const {href, isVisible, isClosed} = useGoToApp();
  const styles = getStyle();

  useEffect(() => {
    if (isMobile && isClosed === undefined) {
      dispatch(setGoToAppHidden(false));
    }
  }, []);

  const onClose = useCallback(() => {
    dispatch(setGoToAppHidden(true));
  }, []);

  if (!isVisible) {
    return null;
  }

  return View({
    onClose,
    styles,
    href,
  });
};
